module.exports = __webpack_public_path__ + "img/5-2.16d5522f.jpg";